module.exports = __webpack_public_path__ + "img/flomvern_smvf.28435582.jpg";